import { differenceInYears } from "date-fns";

const calculateAge = (birthDate: Date | null | undefined): number | null => {
    if (!birthDate) return null;

    return differenceInYears(new Date(), new Date(birthDate));
};

export const isAgeInRange = (birthDate: Date | null | undefined, minAge: number, maxAge: number): boolean => {
    const age = calculateAge(birthDate);
    if (age === null) return false;

    return age >= minAge && age <= maxAge;
};
